import * as DataActionCreator from './firstAction';
import * as TodoActionCreator from './todoAction';

const data = {
    ...DataActionCreator,
    ...TodoActionCreator,
};

export default data;
